import React from 'react';
import { ErrorsWrapperLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import ShadcnErrorsWrapperLayout from './ShadcnErrorsWrapperLayout';

function LegacyErrorsWrapperLayout(props: ErrorsWrapperLayoutProps) {
  const errors = props.errors;
  return (
    <>
      {props.children}
      {errors && errors.length > 0 && (
        <div className={`errors ${props.name}-errors`}>
          {
            errors.map((error) => (
              <div className="error" key={error}>
                {error}
              </div>
            ))
          }
        </div>
      )}
    </>
  );
}

export default function ErrorsWrapperLayout(props: ErrorsWrapperLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnErrorsWrapperLayout {...props} />;
  } else {
    return <LegacyErrorsWrapperLayout {...props} />;
  }
}
